import React, { forwardRef } from "react";
import { useLocation, useMatch, useResolvedPath } from "react-router-dom";

import IconButton from "../custom/IconButton";
import { ListItemButton, Tooltip } from "@mui/material";
import { NavLink } from "react-router-dom";
import styled from "styled-components/macro";

const StyledNavLink = styled(NavLink)`
  display: flex;
  justify-content: center;

  &:hover {
    background-color: inherit;
  }
`;

const CustomRouterLink = forwardRef((props, ref) => {
  const { title, ...rest } = props;
  return (
    <Tooltip placement="right-start" title={props?.title}>
      <div ref={ref}>
        <StyledNavLink {...rest} />
      </div>
    </Tooltip>
  );
});

const Item = styled(ListItemButton)`
  width: 50px;
  font-weight: ${(props) => props.theme.typography.fontWeightRegular};
  svg {
    font-size: 16px;
    width: 16px;
    height: 16px;
    opacity: 1;
  }
`;

const SidebarNavListItem = (props) => {
  const { href, depth = 0, icon: Icon } = props;
  let resolved = useResolvedPath(href || "");
  const match = useMatch({ path: resolved.pathname, end: true });
  const location = useLocation();

  // Checks if the url we are located is included partially or exactly in sidebar and makes the icon active.
  let active;
  if (resolved.pathname.length > 1) {
    location.pathname.includes(resolved.pathname.split("/").pop())
      ? (active = true)
      : (active = false);
  }
  return (
    <React.Fragment>
      <Item
        depth={depth}
        component={CustomRouterLink}
        disableRipple
        to={href}
        activeclassname="active"
        title={props.title}
      >
        {Icon && (
          <IconButton disableRipple $active={!!match || active}>
            <Icon active={!!match || active} />
          </IconButton>
        )}
      </Item>
    </React.Fragment>
  );
};

export default SidebarNavListItem;
